import defineSection from '~/spa/section';
import FAVICONS from 'shared/favicons';
import sectionHead from '~/spa/head';

export default defineSection({
    head: sectionHead({title: 'Circles', icon: FAVICONS.circle, appleIcon: FAVICONS.circle_apple}),
    routes: [
        {
            path: '/users/list/',
            component: () => import(/* webpackChunkName: "accountPages" */ '../ManagedCirclesList.vue'),
            name: 'ManagedCirclesList',
        },
    ]
});
